<template>
  <div class="list-box" style="padding: 0">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.name"
          style="width: 200px"
          placeholder="姓名"
          clearable
          @clear="
            delete state.params.name;
            onLoad();
          "
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
      <li
        style="
          flex: 1;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          line-height: 10px;
        "
      >
        <text style="color: #a2a2a2; font-size: 14px">本次发放数量：</text>
        <text style="font-size: 15px; color: #1e90ff">{{
          props.model?.employee_num
        }}</text>
        <text style="color: #a2a2a2; font-size: 14px; margin-left: 10px"
          >已发放：</text
        >
        <text style="font-size: 15px; color: #080">{{
          props.model?.payed_num
        }}</text>
        <text style="color: #a2a2a2; font-size: 14px; margin-left: 10px"
          >未发放：</text
        >
        <text style="font-size: 15px">{{ props.model?.unpayed_num }}</text>
        <text style="color: #a2a2a2; font-size: 14px; margin-left: 10px"
          >发放失败：</text
        >
        <text style="font-size: 15px; color: #f00">{{
          props.model?.failure_num
        }}</text>
        <el-button
          link
          type="danger"
          icon="Tickets"
          @click="onSetFailure"
          style="margin-left: 20px"
          v-if="$judge_auth('60')"
        >
          发放失败
        </el-button>
        <el-button
          link
          type="success"
          icon="Tickets"
          @click="onSetSuccess"
          style="margin-left: 20px"
          v-if="$judge_auth('60')"
        >
          已发放
        </el-button>
      </li>
    </ul>
    <ul class="list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        class="payroll-record-table"
        size="large"
        @row-click="onRowClick"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          align="center"
        />
        <el-table-column label="算税状态" width="120" align="center">
          <template #default="{ row }">
            <el-tooltip
              effect="dark"
              :content="row.tax_failure_msg"
              v-if="row.tax_failure_msg"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                "
              >
                <c_status
                  arrName="payrollemployee_tax_status"
                  :value="row.tax_status"
                />
                <el-icon><QuestionFilled /></el-icon>
              </div>
            </el-tooltip>
            <c_status
              arrName="payrollemployee_tax_status"
              :value="row.tax_status"
              style="margin: 0 auto"
              v-else
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column label="发放状态" width="120" align="center">
          <template #default="{ row }">
            <el-tooltip
              effect="dark"
              :content="row.pay_failure_msg"
              v-if="row.pay_failure_msg"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                "
              >
                <c_status
                  arrName="payrollemployee_pay_status"
                  :value="row.pay_status"
                />
                <el-icon><QuestionFilled /></el-icon>
              </div>
            </el-tooltip>
            <c_status
              arrName="payrollemployee_pay_status"
              :value="row.pay_status"
              style="margin: 0 auto"
              v-else
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column
          :prop="item.field"
          :label="item.name"
          v-for="item in state.templateSortFields.filter(
            (w) => w.field != 'remark'
          )"
          :key="item"
          :width="['idcard'].includes(item.field) ? 180 : 140"
          align="center"
        >
          <template #default="{ row, column }">
            <div
              v-if="row.isEdit && row.edit.includes(column.property)"
              @click.stop=""
            >
              <el-input-number
                v-model="row[column.property]"
                style="width: 100%"
                :precision="2"
                controls-position="right"
              ></el-input-number>
            </div>
            <template v-else>
              <div v-if="row[column.property]">
                {{ row[column.property] }}
              </div>
              <text v-else>-</text>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" :width="180" align="center">
          <template #default="{ row }">
            <el-input
              v-model="row.remark"
              v-if="row.isEdit"
              @click.stop=""
            ></el-input>
            <text v-else>
              {{ row.remark || "-" }}
            </text>
          </template>
        </el-table-column>
      </el-table>
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showYhdk"
      title="认领到款"
      @close="state.showYhdk = false"
    >
      <c_BankCollectedList
        @close="state.showYhdk = false"
      ></c_BankCollectedList>
    </c_popup>
  </transition>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdits"
      title="批量编辑员工"
      @close="state.showEdits = false"
    >
      <c_PayrollEdits
        v-if="state.showEdits"
        :payroll_id="props.payroll_id"
        :id="state.selectid"
        @success="onEditsSuccess"
      ></c_PayrollEdits>
    </c_popup>
  </transition>
  <el-dialog
    v-model="state.showImport"
    title="导入外协算税单"
    width="40%"
    align-center
  >
    <c_CalcTaxOutsourceImport
      v-if="state.showImport"
      :id="props.model?.id"
      @success="onImportSuccess"
    ></c_CalcTaxOutsourceImport>
  </el-dialog>
  <el-dialog
    v-model="state.showError"
    title="异常处理"
    width="70%"
    align-center
  >
    <c_PayrollError
      v-if="state.showError"
      :payroll_id="props.payroll_id"
      @success="onErrorSuccess"
    ></c_PayrollError>
  </el-dialog>
  <el-dialog v-model="state.showPay" title="申请发薪" width="60%" align-center>
    <c_PayrollPay
      v-if="state.showPay"
      :payroll_id="props.payroll_id"
      :ids="state.selectIds"
      @success="onPaySuccess"
      @close="state.showPay = false"
    ></c_PayrollPay>
  </el-dialog>
  <el-dialog
    v-model="state.showSetAgent"
    title="批量设置扣缴义务人"
    width="400px"
    align-center
  >
    <el-cascader
      v-model="state.withholding_agent.id"
      :options="state.withholding_agent_data"
      :props="{ value: 'id', label: 'name' }"
      placeholder="扣缴义务人"
      filterable
      clearable
      @change="onSetAgentChange"
      style="width: 100%"
    />
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 20px;
      "
    >
      <el-button @click="state.showSetAgent = false">取消</el-button>
      <el-button type="primary" @click="onSetAgentSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref, h } from "vue";
import {
  salarypaymentoutsource_records,
  salarypaymentoutsource_setfailure,
  salarypaymentoutsource_setDone,
} from "@/http/salarypaymentoutsource";
import { priceFormat } from "@/utils/qFormat";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  props: {
    id: Number,
    model: Object,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      params: {},
      statistics: [],
      templateSortFields: [],
      selectFile: {},
      withholding_agent: {},
    });
    onMounted(() => {
      state.params.id = props.model?.id;
      onLoad();
    });

    let sourceList = [];
    const onLoad = () => {
      delete state.tableData;

      salarypaymentoutsource_records(state.params).then((res) => {
        if (res.status == 200) {
          const { list, statistics, templateSortFields } = res.data.data;
          sourceList = JSON.parse(JSON.stringify(list));
          state.tableData = list;
          state.statistics = statistics;
          state.templateSortFields = templateSortFields;
        }
      });
    };

    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      }
      onLoad();
    };

    const getSummaries = () => {
      let res = [];
      res[0] = h("div", { style: { whiteSpace: "nowrap" } }, ["合计"]);
      const keys = Object.keys(state.statistics);
      keys.forEach((key) => {
        const index = state.templateSortFields.findIndex((w) => w.field == key);
        if (index > -1) res[index + 4] = priceFormat(state.statistics[key]);
      });
      return res;
    };

    const onSetFailure = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.prompt(
        `您确定将已选的<strong style='color:#080'>${rows.length}人</strong>标记为<strong style='color:#f00'>发放失败</strong>状态吗？`,
        "发放操作",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "请填写失败原因",
          inputValidator: (value) => {
            if (!value) return false;
            else return true;
          },
          inputErrorMessage: "请填写失败原因",
        }
      ).then(({ value }) => {
        const data = {
          id: props.model?.id,
          employee_id: rows.map((m) => m.employee_id).join(","),
          pay_failure_msg: value,
        };
        salarypaymentoutsource_setfailure(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onSetSuccess = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您确定将已选的<strong style='color:#080'>${rows.length}人</strong>标记为<strong style='color:#080'>已发放</strong>状态吗？`,
        "发放操作",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      ).then(() => {
        const data = {
          id: props.model?.id,
          employee_id: rows.map((m) => m.employee_id).join(","),
        };
        salarypaymentoutsource_setDone(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onCancel = (index) => {
      state.tableData[index] = JSON.parse(JSON.stringify(sourceList[index]));
    };

    return {
      state,
      tableDom,
      props,
      onLoad,
      onRowClick,
      onSortChange,
      getSummaries,
      onSetFailure,
      onCancel,
      onSetSuccess,
    };
  },
};
</script>
<style lang="less">
.payroll-dialog {
  .el-dialog__body {
    flex: 1;
    overflow: hidden;
  }
}
</style>
